<style scoped>
  .Responsive--root {
    width: inherit;
    height: inherit;
  }
</style>

<template>
  <div class="Responsive--root">
    <slot :breakPoint="state.breakPoint"/>
  </div>
</template>

<script>
  import BreakPoint from "../../../delta/BreakPoint";
  import SCREEN from "../../../constant/SCREEN";

  export default {
    props: {
      breakPoint: {
        default: () => new BreakPoint()
      },
      verticalBreakPoint: {
        default: () => new BreakPoint()
      },
      breakPoints: {
        default: () => ([
          new BreakPoint({
            name: SCREEN.MOBILE,
            width: 0
          }),
          new BreakPoint({
            name: SCREEN.TABLET,
            width: 512
          }),
          new BreakPoint({
            name: SCREEN.DESKTOP,
            width: 1024
          }),
        ])
      },
      verticalBreakPoints: {
        default: () => ([
          new BreakPoint({
            name: SCREEN.MOBILE,
            height: 0
          }),
          new BreakPoint({
            name: SCREEN.TABLET,
            height: 512
          }),
          new BreakPoint({
            name: SCREEN.DESKTOP,
            height: 1024
          }),
        ])
      },
      onBreakPointChange: {
        default: () => () => {
        }
      },
      onVerticalBreakPointChange: {
        default: () => () => {
        }
      },
      onBreakPointsChange: {
        default: () => () => {
        }
      },
      onVerticalBreakPointsChange: {
        default: () => () => {
        }
      },
    },
    data() {
      return {
        state: {
          width: 0,
          height: 0,
          breakPoint: this.breakPoint,
          verticalBreakPoint: this.verticalBreakPoint,
          breakPoints: this.orderBreakPoints(this.breakPoints),
          verticalBreakPoints: this.orderVerticalBreakPoints(this.verticalBreakPoints),
        }
      };
    },
    watch: {
      breakPoint: function (v) {
        this.state.breakPoint = v;
      },
      'state.breakPoint': function (v) {
        this.onBreakPointChange(v);
      },
      verticalBreakPoint: function (v) {
        this.state.verticalBreakPoint = v;
      },
      'state.verticalBreakPoint': function (v) {
        this.onVerticalBreakPointChange(v);
      },
      breakPoints: function (v) {
        this.state.breakPoints = this.orderBreakPoints(v);
      },
      'state.breakPoints': function (v) {
        this.onBreakPointsChange(v);
      },
      verticalBreakPoints: function (v) {
        this.state.verticalBreakPoints = this.orderVerticalBreakPoints(v);
      },
      'state.verticalBreakPoints': function (v) {
        this.onVerticalBreakPointsChange(v);
      }
    },
    beforeDestroy() {
      window.removeEventListener("resize", this.onResize);
    },
    beforeMount() {
      window.addEventListener("resize", this.onResize);
    },
    mounted() {
      this.onResize();
    },
    methods: {
      onResize() {
        this.setWidth();
        this.setHeight();
        this.foundBreakPoint();
        this.foundVerticalBreakPoint();
      },
      setWidth() {
        this.state.width = window.innerWidth;
      },
      setHeight() {
        this.state.height = window.innerHeight;
      },
      orderBreakPoints(breakPoints){
        let breakPoints_ = [...breakPoints];
        return breakPoints_.sort((a, b) => b.width - a.width);
      },
      orderVerticalBreakPoints(breakPoints){
        let breakPoints_ = [...breakPoints];
        return breakPoints_.sort((a, b) => b.height - a.height);
      },
      foundBreakPoint() {
        for(let breakPoint of this.state.breakPoints) {
          if (this.state.width >= breakPoint.width) {
            this.state.breakPoint = breakPoint;
            break;
          }
        }
      },
      foundVerticalBreakPoint() {
        for(let verticalBreakPoint of this.state.verticalBreakPoints) {
          if (this.state.height >= verticalBreakPoint.height) {
            this.state.verticalBreakPoint = verticalBreakPoint;
            break;
          }
        }
      }
    }
  };
</script>
